import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal, NgbDate, NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';



@Component({
    selector: 'app-modal-holiday-calendar',
    imports: [CommonModule, FormsModule, NgbDatepickerModule, TranslateModule],
    templateUrl: './modal-holiday-calendar.component.html',
    styleUrl: './modal-holiday-calendar.component.scss'
})
export class ModalHolidayCalendarComponent implements OnInit, OnChanges {

  @Input() holidayData: any[] = [];
  @Input() selectedIndex: number | null = null;

  editStage: 'start' | 'end' = 'start';

  year = new Date().getFullYear();

  private parsedPeriods: Array<{
    index: number;
    start: NgbDate;
    end: NgbDate;
    wraps: boolean;
  }> = [];


  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    console.log('Holiday data en Modal calendar ', this.holidayData);
    this.rebuildParsedPeriods();
  }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes['holidayData']) {
      this.rebuildParsedPeriods();
    }

    if (changes['selectedIndex'] && this.selectedIndex !== null) {
      this.editStage = 'start';
    }
  }


  selectPeriod(index: number): void {
    this.selectedIndex = index;
    this.editStage = 'start';
    // Selección útil para edición (opcional). El pintado del calendario no depende de esto.
  }

  onCalendarSelect(date: NgbDate): void {
    if (this.selectedIndex === null || this.selectedIndex === undefined) {
      return;
    }

    const period = this.holidayData?.[this.selectedIndex];
    if (!period) {
      return;
    }

    if (this.editStage === 'start') {
      period.startMonth = date.month;
      period.startDay = date.day;
      this.editStage = 'end';
    } else {
      period.endMonth = date.month;
      period.endDay = date.day;
      this.editStage = 'start';
    }

    this.rebuildParsedPeriods();
  }

  private parsePeriods(): Array<{ index: number; start: NgbDate; end: NgbDate; wraps: boolean }> {
    const result: Array<{ index: number; start: NgbDate; end: NgbDate; wraps: boolean }> = [];

    (this.holidayData ?? []).forEach((p, index) => {
      // Respecta enable si viene; si no, lo consideramos activo.
      if (p?.enable !== undefined && Number(p.enable) !== 1) {
        return;
      }

      const startMonth = Number(p?.startMonth);
      const startDay = Number(p?.startDay);
      const endMonth = Number(p?.endMonth);
      const endDay = Number(p?.endDay);
      if (!startMonth || !startDay || !endMonth || !endDay) {
        return;
      }

      const start = new NgbDate(this.year, startMonth, startDay);
      const end = new NgbDate(this.year, endMonth, endDay);
      const wraps = end.before(start);

      result.push({ index, start, end, wraps });
    });

    return result.slice(0, 4);
  }

  private rebuildParsedPeriods(): void {
    this.parsedPeriods = this.parsePeriods();
  }

  private isInPeriod(date: NgbDate, period: { start: NgbDate; end: NgbDate; wraps: boolean }): boolean {
    if (!period.wraps) {
      return (date.equals(period.start) || date.equals(period.end) || (date.after(period.start) && date.before(period.end)));
    }
    // Rango que cruza fin de año: [start..31/12] U [01/01..end]
    return date.equals(period.start) || date.equals(period.end) || date.after(period.start) || date.before(period.end);
  }

  getDayClasses(date: NgbDate): Record<string, boolean> {
    // Si hay periodo seleccionado, le damos prioridad visual, pero mantenemos el pintado del resto.
    const selectedHit = this.selectedIndex !== null
      ? this.parsedPeriods.find(p => p.index === this.selectedIndex && this.isInPeriod(date, p))
      : undefined;
    const hit = selectedHit ?? this.parsedPeriods.find(p => this.isInPeriod(date, p));
    if (!hit) {
      return { 'custom-day': true };
    }

    const isStart = date.equals(hit.start);
    const isEnd = date.equals(hit.end);
    const inside = !isStart && !isEnd;

    return {
      'custom-day': true,
      'range': true,
      [`p${hit.index}`]: true,
      'selected-period': this.selectedIndex !== null && hit.index === this.selectedIndex,
      'inside': inside,
      'edge': isStart || isEnd,
      'start': isStart,
      'end': isEnd,
    };
  }

  close(): void {
    this.activeModal.close(this.holidayData);
  }
}
